import React from "react"
import "../bootstrap.min.css"
import styled from "styled-components"

const Section = styled.div`
  margin-bottom: 100px;
`

export default Section
